/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { SupportedLanguages } from '../../common/i18n/SupportedLanguages';
import { endpointConfig } from '../../configuration/configuration';
import type { ApiRequestOptions } from './ApiRequestOptions';

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>;
type Headers = Record<string, string>;

export type OpenAPIConfig = {
    BASE: string;
    VERSION: string;
    WITH_CREDENTIALS: boolean;
    CREDENTIALS: 'include' | 'omit' | 'same-origin';
    TOKEN?: string | Resolver<string> | undefined;
    USERNAME?: string | Resolver<string> | undefined;
    PASSWORD?: string | Resolver<string> | undefined;
    HEADERS?: Headers | Resolver<Headers> | undefined;
    ENCODE_PATH?: ((path: string) => string) | undefined;
};

const LANGUAGE_LOCALSTORAGE_KEY = 'lang';
const getLangState = (): SupportedLanguages => {
    const lang = localStorage.getItem(LANGUAGE_LOCALSTORAGE_KEY);
    if (lang) {
        return lang as SupportedLanguages;
    } else {
        return SupportedLanguages.de;
    }
};

export const OpenAPI: OpenAPIConfig = {
    BASE: endpointConfig.env.SERVICES_BASE_URL,
    VERSION: '0.13.0',
    WITH_CREDENTIALS: endpointConfig.env.NAME !== 'DEV',
    CREDENTIALS: 'include',
    TOKEN: undefined,
    USERNAME: undefined,
    PASSWORD: undefined,
    HEADERS: { 'Accept-Language': getLangState() },
    ENCODE_PATH: undefined,
};
